import { Dispatch, SetStateAction } from 'react';

export enum Alignment {
  Start,
  End,
  Center,
}

export enum Spacing {
  Auto,
  None,
  Small,
  Medium,
  Large,
}

export enum Display {
  Block,
  Inline,
  InlineBlock,
  Flex,
}

export enum DisplayFlexDirection {
  Column,
  Row,
}

export enum DataStatus {
  Idle,
  Loading,
  Ready,
  NotFound,
  Fail,
  Error,
}

export enum FormStatus {
  Pure,
  Submitting,
  Success,
  NotFound,
  Fail,
  Error,
}

export enum LoginPageAction {
  Login,
  Register,
  ForgotPassword,
}

export enum ForgotPasswordResult {
  Success,
  Fail,
  NotFound,
}

export enum ManageRegistrationMode {
  Approval,
  Create,
  EditAtlas,
  EditApi,
}

export class StatusUtil {
  static isFail = (status: FormStatus | DataStatus) => {
    return (
      status === FormStatus.NotFound ||
      status === FormStatus.Fail ||
      status === FormStatus.Error ||
      status === DataStatus.NotFound ||
      status === DataStatus.Fail ||
      status === DataStatus.Error
    );
  };

  static isIdleOrLoading = (status: DataStatus) => {
    return status === DataStatus.Idle || status === DataStatus.Loading;
  };
}

export type DataError = {
  code: string;
  message: string;
};

export type DataState<T> = {
  status: DataStatus;
  error: DataError | null;
  data: T | undefined;
};

export type FormState = {
  status: FormStatus;
  error: DataError | null;
};

export type FormField<T> = {
  value: T;
  valid: boolean;
  message?: string;
};

export type FormStateSetterArgs = {
  status: FormStatus;
  error?: DataError;
};

export type FormStateSetter = (args: FormStateSetterArgs) => void;

export type FormAndFieldsState<T> = {
  fields: T;
  formState: FormState;
  setFields: Dispatch<SetStateAction<T>>;
  setFormState: FormStateSetter;
};

export type CssClasses = {
  readonly [key: string]: string;
};

export type SelectOption = {
  key: string;
  label: string;
  value: string;
};

export type ListItem = {
  key: string;
  label: string;
  subItems?: ListItem[];
};

export class ErrorCode {
  static unknown = 'unknown-error';
  static notFound = 'not-found';
  static serialization = 'serialization-error';
  static accessDenied = 'access-denied';
  static userAlreadyExists = 'user-already-exists';
  static regAlreadyExists = 'reg-already-exists';
  static keyAlreadyExists = 'key-already-exists';
  static passwordMismatch = 'password-mismatch';
  static passwordPolicyViolation = 'password-policy-violation';
}
